import { Component, inject, output, signal, TemplateRef, viewChild } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { noWhitespaceValidator } from "../../../../core/validators";
import { Language, PageMode } from "../../../constants/enums";
import { AppService } from "../../../services";
import { FormActionButtonsComponent, FormInputComponent } from "../../form";

@Component({
  selector: "adaa-smart-tooltips-info-editor-modal",
  imports: [FormInputComponent, FormActionButtonsComponent, TranslatePipe, ReactiveFormsModule],
  templateUrl: "./smart-tooltips-info-editor-modal.html",
  styleUrl: "./smart-tooltips-info-editor-modal.scss",
})
export class SmartTooltipsInfoEditorModalComponent {
  private _formBuilder = inject(FormBuilder);
  private _modalService = inject(NgbModal);
  private _appService = inject(AppService);
  private _translateService = inject(TranslateService);
  private _toastrService = inject(ToastrService);

  toolTipInfoForm: FormGroup = new FormGroup({});
  submitted = signal<boolean>(false);
  modal = viewChild.required<TemplateRef<unknown>>("content");
  modalRef: NgbModalRef;
  PageMode = PageMode;
  info = output<{ descriptionAE: string; descriptionEN: string }>();

  public ngOnInit(): void {
    this._prepareForm();
  }

  private _prepareForm() {
    this.toolTipInfoForm = this._formBuilder.group({
      descriptionAE: this._formBuilder.control<string>("", {
        validators: [Validators.required, noWhitespaceValidator()],
      }),
      descriptionEN: this._formBuilder.control<string>("", {
        validators: [Validators.required, noWhitespaceValidator()],
      }),
    });
  }

  public open() {
    const modalRef = this._modalService.open(this.modal(), {
      animation: true,
      scrollable: false,
      keyboard: false,
      size: "lg",
      centered: true,
      modalDialogClass: this._appService.language() === Language.Arabic ? "modal-rtl" : "modal-ltr",
    });

    this.modalRef = modalRef;
    modalRef.dismissed.subscribe(() => this._resetForm());
    modalRef.closed.subscribe(() => this._resetForm());
  }

  public submit() {
    this.submitted.set(true);
    if (this.toolTipInfoForm.invalid) {
      this._toastrService.error(this._translateService.instant("notification.warning.missing_info"));
      return;
    }

    this.info.emit(this.toolTipInfoForm.value);
    this.modalRef.close();
  }

  public checkInvalid(control: string) {
    return (
      this.toolTipInfoForm.controls[control].errors?.["required"] &&
      (this.toolTipInfoForm.get(control)?.dirty || this.submitted())
    );
  }

  private _resetForm() {
    this.toolTipInfoForm.reset();
    this.toolTipInfoForm.markAsPristine();
    this.toolTipInfoForm.markAsUntouched();
    this.submitted.set(false);
  }
}
